import {useLocationsRequest} from '@yandex-delivery/blocks'
import {isPoint} from '@yandex-taxi/react-integration-api'
import {useMemo} from 'react'

import {useDeliveryType} from './hooks/use-delivery-type'
import {useFetchAddressByLocation} from './hooks/use-fetch-address-by-location'
import {useOrderPointsCoordinates} from './hooks/use-order-points-coordinates'
import {useSourcePointCoordinates} from './hooks/use-source-point-coordinates'
import {useVerticalType} from './hooks/use-vertical-type'
import type {Props} from './types'
import {DeliveryType} from './types'

const isValidPoint = (point: any) => isPoint(point) && point?.[0] !== 0 && point?.[1] !== 0

export function useFormMap({location}: Pick<Props, 'location'>) {
  const {rawVertical: verticalType} = useVerticalType()
  const deliveryType = useDeliveryType()
  const sourcePointCoordinates = useSourcePointCoordinates()
  const orderPointsCoordinates = useOrderPointsCoordinates()
  const {fetchTaxiSuggestHandler, isPending} = useFetchAddressByLocation(location)
  const mapLocationResult = useLocationsRequest({
    centerCoords: location,
    zoom: 16,
    duration: 100,
  })

  const isDragPointAllowed = deliveryType !== DeliveryType.NDD && verticalType !== DeliveryType.NDD
  const isRouteVisible = deliveryType !== DeliveryType.NDD && verticalType !== DeliveryType.NDD

  const routeHash = JSON.stringify(orderPointsCoordinates)

  const routePointCoordinates = useMemo(() => {
    return orderPointsCoordinates.filter(isValidPoint)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeHash])

  return {
    isPending,
    isDragPointAllowed,
    isRouteVisible,
    orderPointsCoordinates,
    routePointCoordinates,
    mapLocationResult,
    fetchTaxiSuggestHandler,
    sourcePointCoordinates,
  } as const
}
